import { Selector, State } from "./types";
import { match } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isEditConstraintRequestFailure(constraint) {
      const req = getState().find((req) => match(req.constraint, constraint));

      return req ? req.request.isFailure : false;
    },
    isEditConstraintRequestPending(constraint) {
      const req = getState().find((req) => match(req.constraint, constraint));

      return req ? req.request.isPending : false;
    },
    isEditConstraintRequestSuccess(constraint) {
      const req = getState().find((req) => match(req.constraint, constraint));

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
